import DeviceBatteryWarning from './DeviceBatteryWarning';

export default DeviceBatteryWarning;
